"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));

var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));

var _Typography = _interopRequireDefault(require("../../elements/Typography"));

var _Tabs2 = _interopRequireDefault(require("./Tabs.css"));

var _utils = require("../../utils");

var Tabs =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Tabs, _React$Component);

  function Tabs() {
    (0, _classCallCheck2.default)(this, Tabs);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Tabs).apply(this, arguments));
  }

  (0, _createClass2.default)(Tabs, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          fullWidth = _this$props.fullWidth,
          tabItems = _this$props.tabItems,
          value = _this$props.value,
          onChange = _this$props.onChange;
      var visibleTabItems = tabItems.filter(function (ti) {
        return (0, _utils.isObject)(ti) && !ti.hidden;
      });
      var displayedTab = visibleTabItems[value] || {};
      return _react.default.createElement("div", {
        className: classes.root
      }, _react.default.createElement(_Tabs.default, {
        value: value < visibleTabItems.length ? value : false,
        onChange: onChange,
        variant: fullWidth ? 'fullWidth' : 'standard',
        classes: {
          root: classes.tabsRoot,
          indicator: "".concat(classes.tabsIndicator, " ").concat(displayedTab.disabled ? 'disabled' : '')
        }
      }, visibleTabItems.map(function (item, index) {
        return _react.default.createElement(_Tab.default, (0, _extends2.default)({
          disableRipple: true,
          classes: {
            selected: classes.tabSelected,
            root: classes.tabRoot
          },
          key: index
        }, item, {
          label: _react.default.createElement(_Typography.default, {
            variant: 'h6'
          }, item.label)
        }));
      })), _react.default.createElement(_Typography.default, {
        variant: 'body1'
      }, displayedTab.content));
    }
  }]);
  return Tabs;
}(_react.default.Component);

Tabs.defaultProps = {
  value: 0,
  fullWidth: false
};
Tabs.propTypes = {
  /**
   * Whether the tabs are full width or not.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * Items passed into the component to be rendered as tabs.
   */
  tabItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    /**
     * Label of the tab component.
     */
    label: _propTypes.default.node.isRequired,

    /**
     * Content displayed inside the tab component when it's selected.
     */
    content: _propTypes.default.node.isRequired,

    /**
     * Whether the tab is selectable or not.
     */
    disabled: _propTypes.default.bool,

    /**
     * Whether the tab is hidden or not.
     */
    hidden: _propTypes.default.bool
  })).isRequired,

  /**
   * The currently selected tab - an index in the array.
   */
  value: _propTypes.default.number,

  /**
   * What to do when the selected tab is changed.
   */
  onChange: _propTypes.default.func.isRequired
};

var _default = (0, _styles.withStyles)(_Tabs2.default)(Tabs);

exports.default = _default;